<script>
import { MAX_BILLING_ADDRESS_LENGTH } from '@/constants';

export default {
  methods: {
    validateAddress() {
      const isUSA = this.$refs.country?.validate && this.fields.country?.id === this.countryUsa.id;
      // only set error if USA selected
      this.$nextTick(() => {
        if (!this.$refs.userAddress?.validate && isUSA) {
          const { value } = this.$refs.userAddress;
          if (value?.length > MAX_BILLING_ADDRESS_LENGTH) {
            this.$set(
              this.errors,
              'user_address',
              'Characters limit exceeded, please use a shorter version.',
            );
          } else {
            this.$set(
              this.errors,
              'user_address',
              'Please enter a valid address.',
            );
          }
        } else {
          this.$delete(this.errors, 'user_address');
        }
      });
    },
  },
};
</script>
